import Vue from 'vue'
import store from './vuex/store'
import VueI18n from 'vue-i18n'
import filters from './utils/filters'
import Draggabilly from 'draggabilly'

import './assets/styles/custom.scss'
import 'element-ui/lib/theme-chalk/display.css'

import {
  Button,
  Col,
  Divider,
  Icon,
  Loading,
  Popover,
  Row,
  Tooltip
} from 'element-ui'
import './assets/styles/material_icons.css'
import deLocale from 'element-ui/lib/locale/lang/de'
import enLocale from 'element-ui/lib/locale/lang/en'
import ElementLocale from 'element-ui/lib/locale'
import de from './locales/de.json'
import en from './locales/en.json'
import App from './App'

var messages = {
  en: {
    dateFormat: 'dd/MM/yyyy',
    firstDayOfWeek: '7',
    deck: en.deck,
    ...enLocale
  },
  de: {
    dateFormat: 'dd.MM.yyyy',
    firstDayOfWeek: '1',
    deck: de.deck,
    ...deLocale
  }
}

var clone = require('lodash/clone')
var cloneDeep = require('lodash/cloneDeep')
var each = require('lodash/each')
var find = require('lodash/find')
var findIndex = require('lodash/findIndex')
var filter = require('lodash/filter')
var flatMap = require('lodash/flatMap')
var isArray = require('lodash/isArray')
var isEmpty = require('lodash/isEmpty')
var isString = require('lodash/isString')

Vue.config.debug = !!(window.initData.debugMode & (1 << 2))
Vue.config.devtools = !!(window.initData.debugMode & (1 << 3))

filters.create()

Vue.use(VueI18n)

Vue.config.lang = window.initData.language.toLowerCase()
Vue.config.fallbackLang = 'de'

var i18n = new VueI18n({
  locale: window.initData.language.toLowerCase(),
  messages,
  silentTranslationWarn: !(window.initData.debugMode & (1 << 4))
})

ElementLocale.i18n(key => i18n.t(key))

Vue.use(Button)
Vue.use(Col)
Vue.use(Divider)
Vue.use(Icon)
Vue.use(Popover)
Vue.use(Row)
Vue.use(Tooltip)
Vue.use(Loading.directive)

Vue.directive('draggabilly', {
  bind: function (elem, binding, vnode, oldVnode) {
    var options = binding.value || {}
    var draggie = new Draggabilly(elem, options)
    var directives = vnode.data.directives
    for (var i in directives) {
      var dir = directives[i]
      if (dir.name === 'draggabilly-on') {
        draggie.on(dir.arg, dir.value)
      } else if (dir.name === 'draggabilly-once') {
        draggie.on(dir.arg, dir.value)
      }
    }
  }
})
Vue.directive('draggabilly-on', {
  bind (elem, binding, vnode, oldVnode) {

  }
})
Vue.directive('draggabilly-once', {
  bind (elem, binding, vnode, oldVnode) {

  }
})

Vue.prototype._clone = clone
Vue.prototype._cloneDeep = cloneDeep
Vue.prototype._each = each
Vue.prototype._find = find
Vue.prototype._findIndex = findIndex
Vue.prototype._filter = filter
Vue.prototype._flatMap = flatMap
Vue.prototype._isArray = isArray
Vue.prototype._isEmpty = isEmpty
Vue.prototype._isString = isString

/* eslint-disable no-new */
new Vue({
  el: '#scheduleApp',
  store,
  i18n,
  filters,
  render: h => h(App)
})
